import React, { PureComponent, Component } from 'react';
import { Steps } from 'antd';
import { Card } from 'antd';
import { Layout } from 'antd';
import { Table } from 'reactstrap';
import Slider from "react-slick";
// import SchedulingOrderSlideCards from './SchedulingOrderSlideCards';
import Image from 'react-bootstrap/lib/Image';
import Grid from 'react-bootstrap/lib/Grid';
import { Row, Col } from 'antd';
import { Button } from 'antd';
import { CardTitle } from 'reactstrap';
// import { PieChart } from 'react-easy-chart';
import { BarChart } from 'react-easy-chart';
import { Pie, Doughnut } from 'react-chartjs-2';
// import ToolTip from './ToolTip';
import ReactTooltip from 'simple-react-tooltip';
import { Slider as Antdslider } from 'antd';
import { ReactiveBase, RangeSlider, ResultList, } from '@appbaseio/reactivesearch';
import AmCharts from "@amcharts/amcharts3-react";
// const AmCharts = require("amcharts3-react");
// const AmCharts = require("@amcharts/amcharts3-react");
// require("amcharts3/amcharts/pie.js");

const Step = Steps.Step;

function generateData() {
    var firstDate = new Date();

    var dataProvider = [];

    for (var i = 0; i < 100; ++i) {
        var date = new Date(firstDate.getTime());

        date.setDate(i);

        dataProvider.push({
            date: date,
            value: Math.floor(Math.random() * 100)
        });
    }

    return dataProvider;
}

class ChartSlideCards extends Component {
    constructor() {
        super();
        this.state = {
            gseStatus: {},
            testconfig3: {
                "type": "pie",
                "theme": "light",
                "dataProvider": [{
                    "country": "Lithuania\n",
                    "litres": 501.9
                }, {
                    "country": "Czech Republic",
                    "litres": 301.9
                }, {
                    "country": "Ireland",
                    "litres": 201.1
                }],
                "valueField": "litres",
                "titleField": "country",
                "balloon": {
                    "fixedPosition": true
                },
                "export": {
                    "enabled": true
                },
                "minRadius": 50,
                "labelRadius": 5
            }
        };
        this.mouseOverHandler = this.mouseOverHandler.bind(this);
        this.mouseOutHandler = this.mouseOutHandler.bind(this);
        this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
        this.onTimeRangeChange = this.onTimeRangeChange.bind(this);
    }

    updateGSEStatus(theStatus) {
        // this.setState({ gseStatus: theStatus });
        this.initCards(theStatus);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps != null && nextProps.gseStatus != null) {
            this.initCards(nextProps);
        }
    }

    componentDidMount() {
        document.getElementsByClassName("slick-slider")[1].style.marginTop = "5px";
        document.getElementsByClassName("slick-slider")[1].style.marginBottom = "5px";
        let aAmChartBrands = document.querySelectorAll('[title="JavaScript charts"]');
        for (var i = 0; i < aAmChartBrands.length; i++) {
            aAmChartBrands[i].style.display = "none";
        }
        if (document.getElementById("__AmCharts_React_1__") !== null && typeof document.getElementById("__AmCharts_React_1__") !== "undefined") {
            document.getElementById("__AmCharts_React_1__").style.height = "238px";
            document.getElementById("__AmCharts_React_1__").style.top = "15px";
        }
        if (document.getElementById("__AmCharts_React_2__") !== null && typeof document.getElementById("__AmCharts_React_2__") !== "undefined") {
            document.getElementById("__AmCharts_React_2__").style.height = "206px";
            document.getElementById("__AmCharts_React_2__").style.top = "15px";
        }
        if (document.getElementById("__AmCharts_React_3__") !== null && typeof document.getElementById("__AmCharts_React_3__") !== "undefined") {
            document.getElementById("__AmCharts_React_3__").style.height = "238px";
            document.getElementById("__AmCharts_React_3__").style.top = "15px";
        }
        if (document.getElementById("__AmCharts_React_4__") !== null && typeof document.getElementById("__AmCharts_React_4__") !== "undefined") {
            document.getElementById("__AmCharts_React_4__").style.height = "238px";
            document.getElementById("__AmCharts_React_4__").style.top = "15px";
        }
    }

    componentDidUpdate() {
        document.getElementsByClassName("slick-slider")[1].style.marginTop = "5px";
        document.getElementsByClassName("slick-slider")[1].style.marginBottom = "5px";
        let aAmChartBrands = document.querySelectorAll('[title="JavaScript charts"]');
        for (var i = 0; i < aAmChartBrands.length; i++) {
            aAmChartBrands[i].style.display = "none";
        }
        if (document.getElementById("__AmCharts_React_1__") !== null && typeof document.getElementById("__AmCharts_React_1__") !== "undefined") {
            document.getElementById("__AmCharts_React_1__").style.height = "238px";
            document.getElementById("__AmCharts_React_1__").style.top = "15px";
        }
        if (document.getElementById("__AmCharts_React_2__") !== null && typeof document.getElementById("__AmCharts_React_2__") !== "undefined") {
            document.getElementById("__AmCharts_React_2__").style.height = "206px";
            document.getElementById("__AmCharts_React_2__").style.top = "15px";
        }
        if (document.getElementById("__AmCharts_React_3__") !== null && typeof document.getElementById("__AmCharts_React_3__") !== "undefined") {
            document.getElementById("__AmCharts_React_3__").style.height = "238px";
            document.getElementById("__AmCharts_React_3__").style.top = "15px";
        }
        if (document.getElementById("__AmCharts_React_4__") !== null && typeof document.getElementById("__AmCharts_React_4__") !== "undefined") {
            document.getElementById("__AmCharts_React_4__").style.height = "238px";
            document.getElementById("__AmCharts_React_4__").style.top = "15px";
        }
    }

    initCards(props) {
        let aTempCards = [];
        aTempCards.push(
            <div className="item" style={{ width: 266 }}>
                <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ height: 210, padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}>
                    <Row type="flex" justify="space-between" align="middle">
                        <Col>
                            <h4>Clusters</h4>
                        </Col>
                        <Col>
                            <h5 className="selected_time_slots">0000A - 1145P</h5>
                        </Col>
                    </Row>
                    {/* <Antdslider range step={100/96} marks={marks} defaultValue={[0, 100]} tipFormatter={null} /> */}
                    <div style={{ height: 14 }} />
                    <ReactiveBase app="schedules" credentials="nY6NNTZZ6:27b76b9f-18ea-456c-bc5e-3a5263ebc63d">
                        <RangeSlider
                            componentId="TimeSlotSensor"
                            range={{
                                start: 0,
                                end: 95,
                            }}
                            rangeLabels={{
                                start: '0000A',
                                end: '1145P',
                            }}
                            showHistogram={false}
                            stepValue={1}
                            onValueChange={(value) => this.onTimeRangeChange(value)}
                        />
                    </ReactiveBase>

                </Card>
            </div>
        );
        if (props.gseStatus != null && typeof props.gseStatus !== "undefined" && !this.isEmptyObj(props.gseStatus)) {
            /* let aThroughputData = [], aTimeslotOCCData = [], aSlackData = [], aOtpData = [];
            for (var i = 0; i < Object.keys(props.gseStatus.Throughput).length; i++) {
                aThroughputData.push({
                    segmentId: Object.keys(props.gseStatus.Throughput)[i],
                    throughput: parseFloat(Object.values(props.gseStatus.Throughput)[i])
                });
            }
            for (var i = 0; i < 96; i++) {
                aTimeslotOCCData.push({
                    timeSlot: i,
                    ambcnt: 0,
                    wccnt: 0,
                    ambcntBySegment:[],
                    wccntBySegment:[]
                });
            }
            for (var i = 0; i < Object.keys(props.gseStatus.TimeslotOCC).length; i++) {
                for(var j=0; j<96; j++){
                    aTimeslotOCCData[j].ambcnt = aTimeslotOCCData[j].ambcnt+Object.values(Object.values(Object.values(props.gseStatus.TimeslotOCC)[i])[j])[0].ambcnt;
                    aTimeslotOCCData[j].wccnt = aTimeslotOCCData[j].wccnt+Object.values(Object.values(Object.values(props.gseStatus.TimeslotOCC)[i])[j])[1].wccnt;
                    aTimeslotOCCData[j].ambcntBySegment.push({
                        segmentId: Object.keys(props.gseStatus.TimeslotOCC)[i],
                        ambcnt: Object.values(Object.values(Object.values(props.gseStatus.TimeslotOCC)[i])[j])[0].ambcnt
                    })
                    aTimeslotOCCData[j].wccntBySegment.push({
                        segmentId: Object.keys(props.gseStatus.TimeslotOCC)[i],
                        wccnt: Object.values(Object.values(Object.values(props.gseStatus.TimeslotOCC)[i])[j])[1].wccnt
                    })
                }
            }
            for (var i = 0; i < Object.keys(props.gseStatus.Slack).length; i++) {
                aSlackData.push({
                    segmentId: Object.keys(props.gseStatus.Slack)[i],
                    slack: parseInt(Object.values(props.gseStatus.Slack)[i])
                });
            }
            for (var i = 0; i < Object.keys(props.gseStatus.OnTimePerformance).length; i++) {
                aOtpData.push({
                    segmentId: Object.keys(props.gseStatus.OnTimePerformance)[i],
                    otp: parseFloat(Object.values(props.gseStatus.OnTimePerformance)[i])
                });
            } */
            if (props.gseStatus.Throughput !== null && props.gseStatus.Throughput.length !== 0) {
                let aThroughputOptions = {
                    "type": "serial",
                    "theme": "light",
                    "legend": {
                        "useGraphSettings": true
                    },
                    "dataProvider": props.gseStatus.Throughput,
                    "synchronizeGrid": true,
                    "valueAxes": [{
                        "id": "value",
                        "axisColor": "#FF6600",
                        "axisThickness": 2,
                        "axisAlpha": 1,
                        "position": "left"
                    }],
                    "graphs": [{
                        "valueAxis": "Throughput",
                        "lineColor": "#FF6600",
                        "bullet": "round",
                        "bulletBorderThickness": 1,
                        "hideBulletsCount": 30,
                        "title": "red line",
                        "valueField": "value",
                        "fillAlphas": 0
                    }],
                    "chartScrollbar": {},
                    "chartCursor": {
                        "cursorPosition": "mouse"
                    },
                    "categoryField": "segid",
                    "categoryAxis": {
                        "parseDates": false,
                        "axisColor": "#DADADA",
                        "minorGridEnabled": true
                    },
                    "export": {
                        "enabled": false,
                        "position": "bottom-right"
                    }
                };

                aTempCards.push(
                    <div className="item" style={{ width: 416, paddingRight: 10 }}>
                        <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ height: 210, padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}>
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <h4 style={{ width: "100%" }}>Throughput</h4>
                                </Col>
                                <Col>
                                    <h5></h5>
                                </Col>
                            </Row>
                            <AmCharts.React style={{ width: 400, height: 300, top: -60, position: "absolute" }} options={aThroughputOptions} />
                        </Card>
                    </div>
                );
            }
            if (props.gseStatus.TimeslotOCC !== null && props.gseStatus.TimeslotOCC.length !== 0) {
                let aTimeslotOCCData = []
                for (var i = 0; i < props.gseStatus.TimeslotOCC.length; i++) {
                    props.gseStatus.TimeslotOCC[i].time = this.convertMinutesToAmPm(props.gseStatus.TimeslotOCC[i].timeslot * 15);
                }
                let aTimeslotOCCOptions = {
                    "type": "serial",
                    "theme": "light",
                    "legend": {
                        "useGraphSettings": true
                    },
                    "dataProvider": props.gseStatus.TimeslotOCC,
                    "synchronizeGrid": true,
                    "valueAxes": [{
                        "id": "ambcnt",
                        "axisColor": "#FF6600",
                        "axisThickness": 2,
                        "axisAlpha": 1,
                        "position": "left"
                    }, {
                        "id": "wccnt",
                        "axisColor": "#B0DE09",
                        "axisThickness": 2,
                        "axisAlpha": 1,
                        "position": "right"
                    }],
                    "graphs": [{
                        "valueAxis": "AmbCnt",
                        "lineColor": "#FF6600",
                        "bullet": "round",
                        "bulletBorderThickness": 1,
                        "hideBulletsCount": 30,
                        "title": "AmbCnt",
                        "valueField": "ambcnt",
                        "fillAlphas": 0
                    }, {
                        "valueAxis": "WcCnt",
                        "lineColor": "#B0DE09",
                        "bullet": "square",
                        "bulletBorderThickness": 1,
                        "hideBulletsCount": 30,
                        "title": "WcCnt",
                        "valueField": "wccnt",
                        "fillAlphas": 0
                    }],
                    "chartScrollbar": {},
                    "chartCursor": {
                        "cursorPosition": "mouse"
                    },
                    "categoryField": "time",
                    "categoryAxis": {
                        "parseDates": false,
                        "axisColor": "#DADADA",
                        "minorGridEnabled": true
                    },
                    "export": {
                        "enabled": false,
                        "position": "bottom-right"
                    }
                };
                aTempCards.push(
                    <div className="item" style={{ width: 416, paddingRight: 10 }}>
                        <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ height: 210, padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}>
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <h4 style={{ width: "100%" }}>Vehicle Occupancy</h4>
                                </Col>
                                <Col>
                                    <h5></h5>
                                </Col>
                            </Row>
                            <AmCharts.React style={{ width: 390, height: 300, top: -60, position: "absolute" }} options={aTimeslotOCCOptions} />
                        </Card>
                    </div>
                );
            }
            if (props.gseStatus.Slack !== null && props.gseStatus.Slack.length !== 0) {
                /* for (var i = 0; i < props.gseStatus.Slack.length; i++) {
                    props.gseStatus.Slack[i].time = this.convertMinutesToAmPm(props.gseStatus.Slack[i].value);
                } */
                let aSlackOptions = {
                    "type": "serial",
                    "theme": "light",
                    "legend": {
                        "useGraphSettings": true
                    },
                    "dataProvider": props.gseStatus.Slack,
                    "synchronizeGrid": true,
                    "valueAxes": [{
                        "id": "value",
                        "axisColor": "#FF6600",
                        "axisThickness": 2,
                        "axisAlpha": 1,
                        "position": "left"
                    }
                        /*{
                            labelFunction: function (number, label, axis) {
                                label = AmCharts.formatDataContextValue("[[time]]", {
                                    time: window.convertMinutesToAmPm(number)
                                });
                                return label;
                            }
                        }*/
                    ],
                    "graphs": [{
                        "valueAxis": "Slack",
                        "lineColor": "#FF6600",
                        "bullet": "round",
                        "bulletBorderThickness": 1,
                        "hideBulletsCount": 30,
                        /* "balloonText": "[[time]]",
                        "balloonFunction": function (item, graph) {
                            var result = graph.balloonText;
                            result = result.replace("[[time]]", item.dataContext.time);
                            return result;
                        },*/
                        // "title": "red line",
                        "valueField": "value",
                        "fillAlphas": 0
                    }],
                    "chartScrollbar": {},
                    "chartCursor": {
                        "cursorPosition": "mouse"
                    },
                    "categoryField": "segid",
                    "categoryAxis": {
                        "parseDates": false,
                        "axisColor": "#DADADA",
                        "minorGridEnabled": true
                    },
                    "export": {
                        "enabled": false,
                        "position": "bottom-right"
                    }
                };
                aTempCards.push(
                    <div className="item" style={{ width: 416, paddingRight: 10 }}>
                        <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ height: 210, padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}>
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <h4 style={{ width: "100%" }}>Slack</h4>
                                </Col>
                                <Col>
                                    <h5></h5>
                                </Col>
                            </Row>
                            <AmCharts.React style={{ width: 400, height: 300, top: -60, position: "absolute" }} options={aSlackOptions} />
                        </Card>
                    </div>
                );
            }
            if (props.gseStatus.OnTimePerformance !== null && props.gseStatus.OnTimePerformance.length !== 0) {
                let aOtpOptions = {
                    "type": "serial",
                    "theme": "light",
                    "legend": {
                        "useGraphSettings": true
                    },
                    "dataProvider": props.gseStatus.OnTimePerformance,
                    "synchronizeGrid": true,
                    "valueAxes": [{
                        "id": "value",
                        "axisColor": "#FF6600",
                        "axisThickness": 2,
                        "axisAlpha": 1,
                        "position": "left"
                    }],
                    "graphs": [{
                        "valueAxis": "OnTimePerformance",
                        "lineColor": "#FF6600",
                        "bullet": "round",
                        "bulletBorderThickness": 1,
                        "hideBulletsCount": 30,
                        "title": "red line",
                        "valueField": "value",
                        "fillAlphas": 0
                    }],
                    "chartScrollbar": {},
                    "chartCursor": {
                        "cursorPosition": "mouse"
                    },
                    "categoryField": "segid",
                    "categoryAxis": {
                        "parseDates": false,
                        "axisColor": "#DADADA",
                        "minorGridEnabled": true
                    },
                    "export": {
                        "enabled": false,
                        "position": "bottom-right"
                    }
                };
                aTempCards.push(
                    <div className="item" style={{ width: 416, paddingRight: 10 }}>
                        <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ height: 210, padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}>
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>
                                    <h4 style={{ width: "100%" }}>OnTimePerformance</h4>
                                </Col>
                                <Col>
                                    <h5></h5>
                                </Col>
                            </Row>
                            <AmCharts.React style={{ width: 400, height: 300, top: -60, position: "absolute" }} options={aOtpOptions} />
                        </Card>
                    </div>
                );
            }
        }
        this.setState({ cards: aTempCards });
    }

    onTimeRangeChange(theValue) {
        console.log(theValue);
        window.document.getElementsByClassName("selected_time_slots")[0].textContent = this.convertMinutesToAmPm(theValue.start * 15) + " - " + this.convertMinutesToAmPm(theValue.end * 15);
        this.props.updateTimeSlotMin(theValue.start);
        this.props.updateTimeSlotMax(theValue.end);
    }

    mouseOverHandler(d, e) {
        this.setState({
            showToolTip: true,
            top: `${e.y - 10}px`,
            left: `${e.x + 10}px`,
            value: d.value,
            key: d.data.key
        });
    }

    mouseMoveHandler(e) {
        if (this.state.showToolTip) {
            this.setState({ top: `${e.y}px`, left: `${e.x + 10}px` });
        }
    }

    mouseOutHandler() {
        this.setState({ showToolTip: false });
    }

    convertMinutesToAmPm(theMins) {
        if (theMins < 0 || theMins >= 1440) {
            return "0000A";
        }
        let aIsAm = true;
        if (theMins >= 12 * 60) {
            aIsAm = false;
        }
        let aHr = 0, aMin = 0;
        let aHrStr = "", aMinStr = "";
        if (aIsAm) {
            if (aIsAm === 0) {
                return "0000A";
            }
            aHr = Math.floor(theMins / 60);
            aMin = theMins % 60;
            if (aHr < 10) {
                aHrStr = "0" + aHr.toString();
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "A";
        } else {
            if (theMins === 12 * 60) {
                return "1200P";
            }
            aHr = Math.floor((theMins - 12 * 60) / 60);
            aMin = (theMins - 12 * 60) % 60;
            if (aHr < 10) {
                if (aHr === 0) {
                    aHrStr = "12";
                } else {
                    aHrStr = "0" + aHr.toString();
                }
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "P";
        }
    }

    getRandomColor() {
        let letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }



    initCards_NIU(props) {
        let chartData = [];
        let firstDate = new Date();
        firstDate.setDate(firstDate.getDate() - 100);
        let visits = 1600;
        let hits = 2900;
        let views = 8700;
        for (var i = 0; i < 100; i++) {
            // we create date objects here. In your data, you can have date strings
            // and then set format of your dates using chart.dataDateFormat property,
            // however when possible, use date objects, as this will speed up chart rendering.
            let newDate = new Date(firstDate);
            newDate.setDate(newDate.getDate() + i);
            visits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
            hits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
            views += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
            chartData.push({
                date: newDate,
                visits: visits,
                hits: hits,
                views: views
            });
        }

        let aTempCards = [];
        let aTempRouteTypes = [];
        let aRouteType = {};
        if (this.props.data != null && this.props.data.length != 0) {
            if (aRouteType == null || aRouteType.length == 0) {
                // aRouteType. = this.props.data[i].route_type;
            }
        }
        let marks = {
            0: '0000A',
            100: '1145P'
        };
        let aLabels = [], aBackgroundColor = [], aHoverBackgroundColor = [], aData = [], aDataSets = [];
        let bLabels = [], bBackgroundColor = [], bHoverBackgroundColor = [], bData = [], bDataSets = [];
        if (this.props.data != null && this.props.data.length != 0) {
            if (props.activeSchedulingOrderCardIdx == 0) {
                for (let i = 0; i < this.props.data.length; i++) {
                    if (this.props.data[i].when_started != null && this.props.data[i].when_started.length != 0 && this.props.data[i].when_ended != null && this.props.data[i].when_ended.length != 0) {
                        let aColor = this.getRandomColor(), bColor = this.getRandomColor();
                        if (aBackgroundColor == null || aBackgroundColor.length == 0) {
                            aBackgroundColor.push(aColor);
                            aHoverBackgroundColor.push(aColor);
                        } else {
                            while (aBackgroundColor.indexOf(aColor) >= 0) {
                                aColor = this.getRandomColor();
                            }
                            aBackgroundColor.push(aColor);
                            aHoverBackgroundColor.push(aColor);
                        }
                        if (bBackgroundColor == null || bBackgroundColor.length == 0) {
                            bBackgroundColor.push(bColor);
                            bHoverBackgroundColor.push(bColor);
                        } else {
                            while (bBackgroundColor.indexOf(bColor) >= 0) {
                                bColor = this.getRandomColor();
                            }
                            bBackgroundColor.push(bColor);
                            bHoverBackgroundColor.push(bColor);
                        }
                        aLabels.push("S#:" + this.props.data[i].sorder + ";Total");
                        aData.push(this.props.data[i].trips_consumed);
                        bLabels.push("S#:" + this.props.data[i].sorder + ";Runtime:" + this.convertSecondsToHrMinSec(this.getDurationInSeconds(this.props.data[i].when_started, this.props.data[i].when_ended)) + "; In Seconds");
                        bData.push(this.getDurationInSeconds(this.props.data[i].when_started, this.props.data[i].when_ended));
                    }
                }
                aDataSets.push({
                    data: aData,
                    backgroundColor: aBackgroundColor,
                    hoverBackgroundColor: aHoverBackgroundColor
                })
                bDataSets.push({
                    data: bData,
                    backgroundColor: aBackgroundColor,
                    hoverBackgroundColor: aHoverBackgroundColor
                })
            } else {
                if (this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].when_started != null && this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].when_started.length != 0 && this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].when_ended != null && this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].when_ended.length != 0) {
                    for (let i = 0; i < 2; i++) {
                        let aColor = this.getRandomColor();
                        if (aBackgroundColor == null || aBackgroundColor.length == 0) {
                            aBackgroundColor.push(aColor);
                            aHoverBackgroundColor.push(aColor);
                            // aLabels.push("S#:" + this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].sorder + ";Scheduled");
                            aLabels.push("Schd:" + this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_scheduled + "/" + this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_consumed + "," + ((this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_scheduled / this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_consumed) * 100).toFixed(2) + '%');
                            aData.push(this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_scheduled);
                        } else {
                            while (aBackgroundColor.indexOf(aColor) >= 0) {
                                aColor = this.getRandomColor();
                            }
                            aBackgroundColor.push(aColor);
                            aHoverBackgroundColor.push(aColor);
                            aLabels.push("S#:" + this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].sorder + ";Unscheduled");
                            // aLabels.push("Unschd:" + (this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_consumed - this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_scheduled)+"/"+this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_consumed+","+((this.props.data[(this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_consumed - this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_scheduled)/this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_consumed) * 100).toFixed(2) + '%');
                            aData.push(this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_consumed - this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].trips_scheduled);
                        }
                    }
                    aDataSets.push({
                        data: aData,
                        backgroundColor: aBackgroundColor,
                        hoverBackgroundColor: aHoverBackgroundColor
                    })
                    let bColor = this.getRandomColor();
                    bBackgroundColor.push(bColor);
                    bHoverBackgroundColor.push(bColor);
                    bLabels.push("S#:" + this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].sorder + ";Runtime:" + this.convertSecondsToHrMinSec(this.getDurationInSeconds(this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].when_started, this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].when_ended)) + "; In Seconds");
                    bData.push(this.getDurationInSeconds(this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].when_started, this.props.data[parseInt(props.activeSchedulingOrderCardIdx) - 1].when_ended));
                    bDataSets.push({
                        data: bData,
                        backgroundColor: bBackgroundColor,
                        hoverBackgroundColor: bHoverBackgroundColor
                    })
                }
            }
        }
        const legendOpts = {
            display: false
        }
        /* if(aLabels==null || aLabels.length==0) {
            aLabels = [
                'Red',
                'Green',
                'Yellow'
            ];
            aDataSets = [{
                data: [300, 50, 100],
                backgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56'
                ],
                hoverBackgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56'
                ]
            }];
        }
        if(bLabels==null || bLabels.length==0) {
            bLabels = [
                'Red',
                'Green',
                'Yellow'
            ];
            bDataSets = [{
                data: [300, 50, 100],
                backgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56'
                ],
                hoverBackgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56'
                ]
            }];
        }
        let aSchedulingData = {
            labels: aLabels,
            datasets: aDataSets
        }
        let aSchedulingRuntimeData = {
            labels: bLabels,
            datasets: bDataSets
        } */
        aTempCards.push(
            <div className="item" style={{ width: 266 }}>
                <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}>
                    <Row type="flex" justify="space-between" align="middle">
                        <Col>
                            <h4>Clusters</h4>
                        </Col>
                        <Col>
                            <h5 className="selected_time_slots">0000A - 1145P</h5>
                        </Col>
                    </Row>
                    {/* <Antdslider range step={100/96} marks={marks} defaultValue={[0, 100]} tipFormatter={null} /> */}
                    <div style={{ height: 14 }} />
                    <ReactiveBase app="schedules" credentials="nY6NNTZZ6:27b76b9f-18ea-456c-bc5e-3a5263ebc63d">
                        <RangeSlider
                            componentId="TimeSlotSensor"
                            range={{
                                start: 0,
                                end: 95,
                            }}
                            rangeLabels={{
                                start: '0000A',
                                end: '1145P',
                            }}
                            showHistogram={false}
                            stepValue={1}
                            onValueChange={(value) => this.onTimeRangeChange(value)}
                        />
                    </ReactiveBase>

                </Card>
            </div>
        );
        if (aLabels !== null && aLabels.length !== 0) {
            let aSchedulingData = {
                labels: aLabels,
                datasets: aDataSets
            }
            aTempCards.push(
                <div className="item" style={{ width: 200 }}>
                    <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ width: 180, height: 130, padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}>
                        <Row type="flex" justify="space-between" align="middle">
                            <Col>
                                <h4>Scheduled Trips</h4>
                            </Col>
                            <Col>
                                <h5></h5>
                            </Col>
                        </Row>
                        {/* <PieChart
                            data-for='chart_tip' data-tip
                            size={100}
                            data={[
                                { key: 'Volanteer', value: 88, color: 'blue' },
                                { key: 'Taxi', value: 66, color: 'red' },
                                { key: 'Agency', value: 50, color: 'green' },
                                { key: 'Unscheduled', value: 10, color: '#e3a51a' }
                            ]}
                            mouseOverHandler={this.mouseOverHandler}
                            mouseOutHandler={this.mouseOutHandler.bind(this)}
                            mouseMoveHandler={this.mouseMoveHandler.bind(this)}
                        /> */}
                        <Pie
                            data={aSchedulingData}
                            legend={legendOpts}
                        />
                    </Card>
                </div>
            );
        } else {
            aTempCards.push(
                <div className="item" style={{ width: 200 }}>
                    <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ width: 180, height: 130, padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}>
                        <Row type="flex" justify="space-between" align="middle">
                            <Col>
                                <h4>Scheduled Trips</h4>
                            </Col>
                            <Col>
                                <h5></h5>
                            </Col>
                        </Row>
                        <p style={{ paddingTop: 20 }}>Data Unavaliable</p>
                    </Card>
                </div>
            );
        }
        if (bLabels !== null && bLabels.length !== 0) {
            let aSchedulingRuntimeData = {
                labels: bLabels,
                datasets: bDataSets
            }
            aTempCards.push(
                <div className="item" style={{ width: 200 }}>
                    <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ width: 180, height: 130, padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}>
                        <Row type="flex" justify="space-between" align="middle">
                            <Col>
                                <h4>GSE Runtime</h4>
                            </Col>
                            <Col>
                                <h5></h5>
                            </Col>
                        </Row>
                        <Doughnut
                            data={aSchedulingRuntimeData}
                            legend={legendOpts}
                        />
                    </Card>
                </div>
            );
        } else {
            aTempCards.push(
                <div className="item" style={{ width: 200 }}>
                    <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ width: 180, height: 130, padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}>
                        <Row type="flex" justify="space-between" align="middle">
                            <Col>
                                <h4>GSE Runtime</h4>
                            </Col>
                            <Col>
                                <h5></h5>
                            </Col>
                        </Row>
                        <p style={{ paddingTop: 20 }}>Data Unavaliable</p>
                    </Card>
                </div>
            );
        }
        /* aTempCards.push(
            <div className="item" style={{ width: 416 }}>
                <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{height:160, padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}>
                    <Row type="flex" justify="space-between" align="middle">
                        <Col>
                            <h4>Pie Chart</h4>
                        </Col>
                        <Col>
                            <h5></h5>
                        </Col>
                    </Row>
                    <AmCharts.React style={{ width: 400, height: 300, top: -60, position: "absolute" }} options={this.state.testconfig3} />
                </Card>
            </div>
        ); */
        aTempCards.push(
            <div className="item" style={{ width: 416 }}>
                <Card bordered={false} style={{ backgroundColor: "rgba(255, 255, 255,0)" }} bodyStyle={{ height: 160, padding: 8, backgroundColor: "white", borderTopLeftRadius: 25, borderTopRightRadius: 25, borderBottomLeftRadius: 25, borderBottomRightRadius: 25 }}>
                    <Row type="flex" justify="space-between" align="middle">
                        <Col>
                            <h4>Pie Chart</h4>
                        </Col>
                        <Col>
                            <h5></h5>
                        </Col>
                    </Row>
                    <AmCharts.React style={{ width: 400, height: 300, top: -60, position: "absolute" }} options={{
                        "type": "serial",
                        "theme": "light",
                        "legend": {
                            "useGraphSettings": true
                        },
                        "dataProvider": chartData,
                        "synchronizeGrid": true,
                        "valueAxes": [{
                            "id": "v1",
                            "axisColor": "#FF6600",
                            "axisThickness": 2,
                            "axisAlpha": 1,
                            "position": "left"
                        }, {
                            "id": "v2",
                            "axisColor": "#FCD202",
                            "axisThickness": 2,
                            "axisAlpha": 1,
                            "position": "right"
                        }, {
                            "id": "v3",
                            "axisColor": "#B0DE09",
                            "axisThickness": 2,
                            "gridAlpha": 0,
                            "offset": 50,
                            "axisAlpha": 1,
                            "position": "left"
                        }],
                        "graphs": [{
                            "valueAxis": "v1",
                            "lineColor": "#FF6600",
                            "bullet": "round",
                            "bulletBorderThickness": 1,
                            "hideBulletsCount": 30,
                            "title": "red line",
                            "valueField": "visits",
                            "fillAlphas": 0
                        }, {
                            "valueAxis": "v2",
                            "lineColor": "#FCD202",
                            "bullet": "square",
                            "bulletBorderThickness": 1,
                            "hideBulletsCount": 30,
                            "title": "yellow line",
                            "valueField": "hits",
                            "fillAlphas": 0
                        }, {
                            "valueAxis": "v3",
                            "lineColor": "#B0DE09",
                            "bullet": "triangleUp",
                            "bulletBorderThickness": 1,
                            "hideBulletsCount": 30,
                            "title": "green line",
                            "valueField": "views",
                            "fillAlphas": 0
                        }],
                        "chartScrollbar": {},
                        "chartCursor": {
                            "cursorPosition": "mouse"
                        },
                        "categoryField": "date",
                        "categoryAxis": {
                            "parseDates": true,
                            "axisColor": "#DADADA",
                            "minorGridEnabled": true
                        },
                        "export": {
                            "enabled": true,
                            "position": "bottom-right"
                        }
                    }} />
                </Card>
            </div>
        );
        this.setState({ cards: aTempCards });
    }

    isEmptyObj(obj) {
        for (let prop in obj) {
            if (obj.hasOwnProperty(prop))
                return false;
        }
        return JSON.stringify(obj) === JSON.stringify({});
    }

    getDurationInSeconds(theStartTime, theEndTime) {
        if (theStartTime == null || theStartTime.length == 0 || theEndTime == null || theEndTime.length == 0) {
            return 0;
        }
        var aStartTime = new Date(theStartTime);
        var aStartTimestamp = aStartTime.getTime();
        var aEndTime = new Date(theEndTime);
        var aEndTimestamp = aEndTime.getTime();
        if (aEndTimestamp >= aStartTimestamp) {
            return parseInt((aEndTimestamp - aStartTimestamp) / 1000, 10);
        } else {
            return 0;
        }
    }

    convertSecondsToHrMinSec(theSec) {
        let aHr = "", aMin = "", aSec = "";
        if (theSec < 60) {
            aSec = theSec + "Secs";
        } else {
            if (parseInt(theSec / 60, 10) < 60) {
                aMin = parseInt(theSec / 60, 10) + "Mins";
                aSec = theSec % 60 + "Secs";
            } else {
                aHr = parseInt(parseInt(theSec / 60, 10) / 60, 10) + "Hrs";
                aMin = parseInt(theSec / 60, 10) % 60 + "Mins";
                aSec = theSec % 60 + "Secs";
            }
        }
        return aHr + aMin + aSec;
    }

    render() {
        const settings = {
            dots: false,
            draggable: false,
            className: "center",
            centerMode: true,
            infinite: false,
            centerPadding: "60px",
            slidesToShow: 1,
            speed: 500,
            swipeToSlide: true,
            focusOnSelect: true,
            variableWidth: true,
            rows: 1,
            slidesPerRow: 1,
            initialSlide: 1
        };
        return (
            <div>
                <Slider {...settings} style={{ height: 266 }}>
                    {this.state.cards}
                </Slider>
            </div>
        );
    }
}

export default ChartSlideCards;



// WEBPACK FOOTER //
// ./src/Componets/ChartSlideCards.js